import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Button, Heading, Link } from '@primer/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Overview`}</h2>
    <p>{`Anchored overlay provides an anchor that will open a floating overlay positioned relative to the anchor. The overlay can be opened and navigated using a keyboard or mouse.`}</p>
    <p>{`See also `}<a parentName="p" {...{
        "href": "https://primer.style/react/Overlay#positioning"
      }}>{`Overlay positioning`}</a></p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://primer.style/react/Overlay"
        }}>{`Overlay`}</a></li>
    </ul>
    <h2>{`Accessibility`}</h2>
    <p>{`The anchored overlay menu will automatically receive a focus trap and focus zone. Use up/down keys to navigate between buttons.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      